import { Injectable, Pipe } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Pipe({ name: 'CategoryService' })

@Injectable()
export class CategoryService {

  constructor(private httpClient: HttpClient) { }

  getAllCategoryByCategoryTypeCode(categoryTypeCode: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/category/getAllCategoryByCategoryTypeCode";
    return this.httpClient.post(url, { CategoryTypeCode: categoryTypeCode })
      .map((response: Response) => {
        return response;
      });
  }
  getAllCategoryByCategoryTypeCodeAsyc(categoryTypeCode: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/category/getAllCategoryByCategoryTypeCode";
    return new Promise((resolve, reject) => {
      return this.httpClient.post(url, { CategoryTypeCode: categoryTypeCode }).toPromise()
        .then((response: Response) => {
          resolve(response);
        });
    });
    //return this.httpClient.post(url, {})
    //  .map((response: Response) => {
    //    return response;
    //  });
  }
  //getAllCategoryByCategoryTypeCodeAsyc(categoryTypeCode: string) {
  //  let url = localStorage.getItem('ApiEndPoint') + "/api/category/getAllCategoryByCategoryTypeCode";
  //  // return new Promise((resolve, reject) => {
  //  //   return this.httpClient.post(url, { CategoryTypeCode: categoryTypeCode }).toPromise()
  //  //     .then((response: Response) => {
  //  //       resolve(response);
  //  //     });
  //  // });
  //  return this.httpClient.post(url, { CategoryTypeCode: categoryTypeCode })
  //    .map((response: Response) => {
  //      return response;
  //    });
  //}

  getAllCategory() {
    let url = localStorage.getItem('ApiEndPoint') + "/api/category/getAllCategory";
    return this.httpClient.post(url, {})
      .map((response: Response) => {
        return response;
      });
  }

  getCategoryById(categoryId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/category/getCategoryById";
    return this.httpClient.post(url, { CategoryId: categoryId })
      .map((response: Response) => {
        return response;
      });
  }

  createCategory(categoryName: string, categoryCode: string, categoryTypeId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/category/createCategory";
    return this.httpClient.post(url, { CategoryName: categoryName, CategoryCode: categoryCode, CategoryTypeId: categoryTypeId })
      .map((response: Response) => {
        return response;
      });
  }

  deleteCategoryById(categoryId: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/category/deleteCategoryById";
    return this.httpClient.post(url, { CategoryId: categoryId })
      .map((response: Response) => {
        return response;
      });
  }

  editCategoryById(categoryId: string, categoryName: string, categoryCode: string) {
    let url = localStorage.getItem('ApiEndPoint') + "/api/category/editCategoryById";
    return this.httpClient.post(url, { CategoryId: categoryId, CategoryName: categoryName, CategoryCode: categoryCode })
      .map((response: Response) => {
        return response;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/category.service.ts